import { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';
import React from 'react';

import { api } from '@/services/api';
import TemplateEvents, {
  TemplateListEventsProps,
} from '@/templates/list-events';

const LIMIT_PER_PAGE = 12;

const EventList: NextPage<TemplateListEventsProps> = props => {
  return (
    <>
      <Head>
        <title>Eventos | BoraTickets</title>
      </Head>
      <TemplateEvents limit={LIMIT_PER_PAGE} {...props} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps<TemplateListEventsProps> =
  async () => {
    const response = await api.get('/v1/web/events', {
      params: { page: 1, limit: LIMIT_PER_PAGE },
    });

    return {
      props: {
        events: response.data.events,
      },
    };
  };

export default EventList;
